function setSeznamMapMarkers(seznamMap, markers = []){

    //seznamMap.addControl(new SMap.Control.Sync({bottomSpace:30}));
    seznamMap.addDefaultLayer(SMap.DEF_BASE).enable();

    let mouseEvents = new SMap.Control.Mouse(SMap.MOUSE_PAN | SMap.MOUSE_WHEEL | SMap.MOUSE_ZOOM); /* Ovládání myší */
    seznamMap.addControl(mouseEvents);

    let coordinations = [];
    let mapMarkers = [];

    for (let i = 0; i < markers.length; i++) {

        let markerCoordination = SMap.Coords.fromWGS84(markers[i][2], markers[i][1]);

        let markerOptions = {
            url: BASE_PATH + '/front/design/marker.png'
        };

        let markerCard = new SMap.Card();
        markerCard.getBody().innerHTML = markers[i][0];

        let marker = new SMap.Marker(markerCoordination, null, markerOptions);
        marker.decorate(SMap.Marker.Feature.Card, markerCard);

        coordinations.push(markerCoordination);
        mapMarkers.push(marker);
    }

    let markersLayer = new SMap.Layer.Marker();
    seznamMap.addLayer(markersLayer);
    markersLayer.enable();

    for(let mapMarker of mapMarkers){
        markersLayer.addMarker(mapMarker);
    }

    let centerZoom = seznamMap.computeCenterZoom(coordinations);
    seznamMap.setCenterZoom(centerZoom[0], centerZoom[1]);

}


function initSeznamMapWhenNeeded(element, locations, zoom = 15){
    element.data('map-initialized', true);
    console.log(element.get(0));
    let seznamMap = new SMap(JAK.gel(element.get(0)));
    setSeznamMapMarkers(seznamMap, locations);
    seznamMap.setZoom(zoom);
}